<template>
  <div class="container">
    <page-header></page-header>
    <search></search>
    <div>
      <div class="section feature-section">
        <div class="section-container">
          <div class="dashboard-list">
            <div class="dashboard">
              <div class="dashboard-item"></div>
              <div class="dashboard-item">
                <p class="dashboard__key">当前区块高度</p>
                <p class="dashboard__value">{{ home.current_height | formatNum }}</p>
              </div>
              <div class="dashboard-item">
                <p class="dashboard__key">平均出块时间</p>
                <p class="dashboard__value">{{ home.average_block_time }}</p>
              </div>
              <div class="dashboard-item">
                <p class="dashboard__key">历史TPS</p>
                <p class="dashboard__value">
                  {{ home.transaction_per_second_max | formatNum }}
                </p>
              </div>
              <div class="dashboard-item">
                <p class="dashboard__key">已铸造</p>
                <p class="dashboard__value">{{ home.total_cast_count | formatNum }}</p>
              </div>
              <div class="dashboard-item">
                <p class="dashboard__key">累积交易笔数</p>
                <p class="dashboard__value">
                  {{ home.total_transactions_count | formatNum }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section block-section">
        <div class="bg"></div>
        <div class="section-container">
          <div class="comp-title-wrapper">
            <p class="comp-title">最近区块高度</p>
          </div>
          <div class="record-list">
            <div
              class="record"
              v-for="(item, index) in blockFrontList"
              :key="item.number"
            >
              <p class="record__time">{{ item.time }}秒前</p>
              <p class="record__title">#{{ item.number }}</p>
              <p class="record__trade-num">{{ item.transaction_count }}笔交易</p>
            </div>
          </div>
        </div>
      </div>
      <div class="section transation-section">
        <div class="bg"></div>
        <div class="section-container">
          <div class="comp-title-wrapper">
            <p class="comp-title">最近交易记录</p>
          </div>
          <div class="record-list">
            <div class="record" v-for="item in transFrontList" :key="item.tx_id">
              <div class="record__title">
                <a
                  class="link-a"
                  href="javascript:;"
                  :title="item.tx_id"
                  @click="reloadPage('trade_hash', item.tx_id)"
                  >{{ item.tx_id }}</a
                >
              </div>
              <p class="transation-detail">
                <a
                  class="link-a"
                  href="javascript:;"
                  :title="item.addr"
                  @click="reloadPage('addr', item.addr)"
                  >{{ item.addr }}</a
                >
                <span class="right-arrow"></span>
                <a
                  class="link-a"
                  href="javascript:;"
                  :title="item.to_addr"
                  @click="reloadPage('addr', item.to_addr)"
                  >{{ item.to_addr }}</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="decoration-bottom"></div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import pageHeader from "@/components/page-header";
import pageFooter from "@/components/page-footer";
import search from "@/components/search";
import { formatNum } from "@/utils/comm.js";
export default {
  name: "home",
  components: {
    pageHeader,
    pageFooter,
    search,
  },
  data() {
    return {
      interval: null,
      home: {
        current_height: "",
        transaction_per_second_max: "",
        average_block_time: "",
        total_transactions_count: 0,
        total_cast_count: 0,
      },
      blockFrontList: [],
      transFrontList: [],
    };
  },
  filters: {
    formatNum(value) {
      return Number(value).toLocaleString();
    },
  },
  mounted() {
    this.queryHomeData();
    this.interval = setInterval(() => {
      this.queryHomeData();
    }, 3000);
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },
  methods: {
    reloadPage(type, key) {
      this.$router.push(`search?type=${type}&key=${key}`);
    },

    queryHomeData() {
      this.$api.queryHomeData().then((res) => {
        res = res.data;
        this.loading = false;
        if (res.code == 1) {
          let data = res.data;
          data.number = formatNum(data.current_height);
          data.total_cast = formatNum(data.total_cast_count);
          if (this.home.number != data.number) {
            this.recentBlockHeight();
            this.recentTransactionRecords();
          }
          this.home = data || {};
        } else {
          this.home = {};
        }
      });
    },
    recentTransactionRecords() {
      this.$api.recentTransactionRecords().then((res) => {
        res = res.data;
        this.loading = false;
        if (res.code == 1) {
          this.transFrontList = res.data || [];
        } else {
          this.transFrontList = [];
        }
      });
    },
    recentBlockHeight() {
      this.$api.recentBlockHeight().then((res) => {
        res = res.data;
        this.loading = false;
        if (res.code == 1) {
          let data = res.data || [];
          let newTime = new Date().getTime();
          data[data.length - 1].isOld = true;
          this.blockFrontList = data.map((item) => {
            let time = Math.ceil((newTime - item.timestamp) / 1000);
            if (time < 0) {
              time = 0;
            }
            item.time = time;
            return item;
          });
        } else {
          this.blockFrontList = [];
        }
      });
    },
  },
};
</script>

<style scoped>
.section {
  background: #000;
  padding-top: 0;
}

.section.feature-section {
  margin: 180px auto 0;
  padding: 0;
  background: transparent;
}

.section.feature-section .section-container {
  position: relative;
}

.section.feature-section .section-container:before {
  content: "";
  width: 374px;
  height: 374px;
  background-image: url("../../assets/box_small.png");
  background-size: 100% 100%;
  position: absolute;
  left: -15px;
  top: -140px;
  z-index: 1;
}

.section.feature-section .section-container:after {
  content: "";
  width: 644px;
  height: 644px;
  background-image: url("../../assets/box_small.png");
  background-size: 100% 100%;
  position: absolute;
  right: -100px;
  top: -100px;
  z-index: -1;
}

.section.feature-section .dashboard-list {
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: linear-gradient(
    69deg,
    rgba(255, 255, 255, 0.2) 10.42%,
    rgba(255, 255, 255, 0.04) 77.11%
  );
  box-shadow: 0px 1.197px 29.915px 0px rgba(69, 42, 124, 0.1);
  backdrop-filter: blur(80px);
}

.section.feature-section .dashboard {
  display: flex;
  flex-wrap: wrap;
}

.section.feature-section .dashboard-item {
  width: 39%;
  height: 250px;
  padding-top: 40px;
  padding-left: 60px;
  box-sizing: border-box;
}

.section.feature-section .dashboard-item:nth-child(3n + 1) {
  width: 22%;
}

.section.feature-section .dashboard__key {
  font-size: 32px;
  font-weight: 600;
}

.section.feature-section .dashboard__value {
  font-weight: bold;
  font-family: DIN;
  font-size: 70px;
  position: relative;
  background: linear-gradient(260deg, #0047ff -13.37%, #00bcd4 109.53%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.block-section {
  margin-top: 120px;
}

.block-section .bg {
  height: 533px;
  background: #000 url("../../assets/block_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.block-section .section-container {
  margin: -160px auto 0;
}

.block-section .record-list {
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: linear-gradient(
    69deg,
    rgba(255, 255, 255, 0.2) 10.42%,
    rgba(255, 255, 255, 0.04) 77.11%
  );
  box-shadow: 0px 1.197px 29.915px 0px rgba(69, 42, 124, 0.1);
  backdrop-filter: blur(35px);
  display: flex;
  flex-wrap: wrap;
}

.block-section .record-list .record {
  width: 25%;
  height: 184px;
  padding: 40px 0 0 64px;
  box-sizing: border-box;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
}

.block-section .record-list .record:nth-child(4n + 1) {
  border-left: none;
}

.block-section .record-list .record:nth-child(n + 4) {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.block-section .record-list .record .record__time {
  color: rgba(255, 255, 255, 0.6);
  font-family: DIN;
  font-size: 16px;
  font-weight: 500;
}

.block-section .record-list .record .record__title {
  margin-top: 10px;
  color: #fff;
  font-family: DIN;
  font-size: 22px;
  font-weight: 700;
  position: relative;
}

.block-section .record-list .record .record__title:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #1fcff1;
  border-radius: 100%;
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
}

.block-section .record-list .record .record__trade-num {
  margin-top: 16px;
  font-family: DIN;
  font-size: 18px;
  font-weight: 500;
  background: linear-gradient(90deg, #1a7cec 0%, #24d8f3 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.transation-section .bg {
  height: 533px;
  background: #000 url("../../assets/transation_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.transation-section .section-container {
  margin: -200px auto 0;
}

.transation-section .record-list .record {
  padding: 60px;
  border-radius: 8px;
  border: 1px solid #fff;
  background: linear-gradient(
    69deg,
    rgba(255, 255, 255, 0.2) 10.42%,
    rgba(255, 255, 255, 0.04) 77.11%
  );
  box-shadow: 0px 1.197px 29.915px 0px rgba(69, 42, 124, 0.1);
  backdrop-filter: blur(35px);
}

.transation-section .record-list .record + .record {
  margin-top: 30px;
}

.transation-section .record-list .record .record__title {
  color: #fff;
  font-family: DIN;
  font-size: 28px;
  font-weight: 700;
  position: relative;
}

.transation-section .record-list .record .record__title:after {
  content: "";
  width: 8px;
  height: 8px;
  background: #1fcff1;
  border-radius: 100%;
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%);
}

.transation-section .record-list .record .transation-detail {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: DIN;
  font-size: 24px;
  font-weight: 500;
  background: linear-gradient(90deg, #1a7cec 0%, #24d8f3 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.transation-section .record-list .record .link-a {
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  color: #fff;
}

.transation-section .record-list .record .right-arrow {
  display: block;
  margin: 0 30px;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  background: url("../../assets/arrow.png") no-repeat;
  background-size: 100%;
}

.decoration-bottom {
  width: 1200px;
  height: 1021px;
  background: #000 url("../../assets/decoration_bottom.png");
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: -1000px;
}

@media (max-width: 1199px) {
  .section.feature-section {
    margin: 50px auto 0;
  }
  .section.feature-section .section-container:before {
    width: 187px;
    height: 187px;
    left: -15px;
    top: -70px;
  }
  .section.feature-section .section-container:after {
    width: 322px;
    height: 322px;
    right: 0px;
    top: 50px;
  }
  .section.feature-section .dashboard-list {
    border-radius: 10px;
  }
  .section.feature-section .dashboard-item {
    width: 50%;
    height: 100px;
    padding-top: 10px;
    padding-left: 10px;
  }
  .section.feature-section .dashboard-item:nth-child(1) {
    width: 40%;
  }
  .section.feature-section .dashboard-item:nth-child(2) {
    width: 60%;
  }
  .section.feature-section .dashboard-item:nth-child(4) {
    width: 50%;
  }
  .section.feature-section .dashboard__key {
    font-size: 16px;
  }
  .section.feature-section .dashboard__value {
    font-size: 30px;
  }
  .block-section {
    margin-top: 60px;
  }
  .block-section .bg {
    height: 200px;
  }
  .block-section .record-list .record {
    width: 50%;
    height: 100px;
    padding: 10px 0 0 30px;
  }
  .block-section .record-list .record:nth-child(2n + 1) {
    border-left: none;
  }
  .block-section .record-list .record:nth-child(n + 3) {
    border-top: 1px solid rgba(255, 255, 255, 0.2);
  }
  .block-section .record-list .record .record__time {
    font-size: 14px;
  }
  .block-section .record-list .record .record__title {
    margin-top: 5px;
    font-size: 18px;
  }
  .block-section .record-list .record .record__trade-num {
    margin-top: 5px;
    font-size: 16px;
  }
  .transation-section .bg {
    height: 250px;
  }
  .transation-section .record-list .record {
    padding: 10px 10px 10px 30px;
    border-radius: 4px;
  }
  .transation-section .record-list .record + .record {
    margin-top: 15px;
  }
  .transation-section .record-list .record .record__title {
    font-size: 18px;
  }
  .transation-section .record-list .record .transation-detail {
    margin-top: 10px;
    font-size: 18px;
  }
  .transation-section .record-list .record .right-arrow {
    margin: 0 10px;
    width: 12px;
    height: 12px;
  }
  .decoration-bottom {
    width: 100%;
    height: 300px;
    margin-top: -300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue